import createReactClass from "create-react-class";
import React from "react";
import { AutoSizer, Column, SortDirection, Table } from "react-virtualized";
import { compareDetailsStore } from "../stores/compareDetails";
import { compareSubdivisionStore } from "../stores/compareSubdivision";
import { formValidation } from "../util/formValidation";
import { ContentBox } from "./admin/ContentBox";
import "../css/adminScreen.css";
var dataForIssuedTab;
var ifDataModified = false;

function getStateFromStores() {
  return {
    data: compareDetailsStore.getCompareGuids(),
    filteredData: compareDetailsStore.getCompareGuids(),
    loading: compareDetailsStore.guidListLoading(),
    disableHeader: false,
    useDynamicRowHeight: false,
    rowCount: 10,
    scrollToIndex: undefined,
    height: 325,
    rowHeight: 23,
    headerHeight: 30,
    overscanRowCount: 10,
    hideIndexRow: false,
    sortDirection: SortDirection.ASC,
    defaultID: 0,
    alertVisible: false,
    alertMessage: "",
    defaultChecked: true,
    previousSub: "",
    previousTab: "true",
  };
}

export const CompareGuidList = createReactClass({
  componentDidMount: function () {
    compareDetailsStore.subscribe(this._onChange);
    compareSubdivisionStore.subscribe(this._onChange);
  },

  componentWillUnmount: function () {
    compareDetailsStore.unsubscribe(this._onChange);
    compareSubdivisionStore.unsubscribe(this._onChange());
  },

  getInitialState: function () {
    return getStateFromStores();
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  onGuidRowClick: function (rowData) {
    //ServerActions.viewRequestHistory(rowData.syncId);

    console.log("guid click");
  },

  _sort: function ({ sortBy, sortDirection }) {
    window.searchSortActive = true;
    const comparer = (a, b) => {
      ifDataModified = true;

      if (sortDirection === "ASC") {
        return a[sortBy] > b[sortBy] ? 1 : -1;
      } else if (sortDirection === "DESC") {
        return a[sortBy] < b[sortBy] ? 1 : -1;
      }
    };
    var rows;
    if (ifDataModified) {
      rows = this.state.filteredData.sort(comparer);
    } else {
      rows = this.props.data.sort(comparer);
    }
    dataForIssuedTab = rows;
    this.setState({ filteredData: dataForIssuedTab });
    this.setState({ sortBy, sortDirection });
  },

  rowClassName: function ({ index }) {
    if (index < 0) {
      return "headerRow";
    } else {
      var item = this.state.filteredData[index];
      if (
        item.compareCode == "R" ||
        item.compareCode == "M" ||
        item.compareCode == "A"
      ) {
        return "bold " + (index % 2 === 0 ? "oddRow" : "evenRow");
      }
      return index % 2 === 0 ? "oddRow" : "evenRow";
    }
  },

  _noRowsRenderer: function () {
    return <div className="issuedNoRows">No rows found</div>;
  },

  formatValue: function ({ dataKey, rowData }) {
    if (dataKey == "leftGuidId") {
      return rowData.leftGuid ? rowData.leftGuid.id : "--";
    } else if (dataKey == "leftStartMP") {
      if (rowData.leftGuid != null)
        return (
          formatMp(rowData.leftGuid.beginMp) +
          (rowData.leftGuid.mpSuffix ? rowData.leftGuid.mpSuffix : "")
        );
      else return "--";
    } else if (dataKey == "leftEndMP") {
      if (rowData.leftGuid != null)
        return (
          formatMp(rowData.leftGuid.endMp) +
          (rowData.leftGuid.mpSuffix ? rowData.leftGuid.mpSuffix : "")
        );
      else return "--";
    } else if (dataKey == "leftTrackName") {
      if (rowData.leftGuid != null) return rowData.leftGuid.trackName;
      else return "--";
    } else if (dataKey == "code") {
      return rowData.compareCode ? rowData.compareCode : "--";
    } else if (dataKey == "rightGuidId") {
      return rowData.rightGuid ? rowData.rightGuid.id : "--";
    } else if (dataKey == "rightStartMP") {
      if (rowData.rightGuid != null)
        return (
          formatMp(rowData.rightGuid.beginMp) +
          (rowData.rightGuid.mpSuffix ? rowData.rightGuid.mpSuffix : "")
        );
      else return "--";
    } else if (dataKey == "rightEndMP") {
      if (rowData.rightGuid != null)
        return (
          formatMp(rowData.rightGuid.endMp) +
          (rowData.rightGuid.mpSuffix ? rowData.rightGuid.mpSuffix : "")
        );
      else return "--";
    } else if (dataKey == "rightTrackName") {
      if (rowData.rightGuid != null) return rowData.rightGuid.trackName;
      else return "--";
    }
  },

  render: function () {
    const {
      rowHeight,
      headerHeight,
      overscanRowCount,
      sortBy,
      sortDirection,
      filteredData,
    } = this.state;
    var hig;
    if (screen.height <= 768) {
      hig = "72vh";
    } else {
      hig = "81vh";
    }

    return (
      <ContentBox className="currentSchematic">
        <div style={{ height: hig }}>
          <AutoSizer>
            {({ height, width }) => (
              <Table
                ref="Table"
                disableHeader={false}
                headerClassName="historyheaderColumn"
                width={width}
                height={height}
                headerHeight={headerHeight}
                rowHeight={rowHeight}
                overscanRowCount={overscanRowCount}
                rowCount={filteredData.length}
                rowClassName={this.rowClassName}
                sort={this._sort}
                sortBy={sortBy}
                sortDirection={sortDirection}
                noRowsRenderer={this._noRowsRenderer}
                onRowDoubleClick={this.onGuidRowClick}
                rowGetter={({ index }) => filteredData[index]}
              >
                <Column
                  width={width * 0.25}
                  label="Guid Id"
                  dataKey="leftGuidId"
                  cellRenderer={this.formatValue}
                />
                <Column
                  width={width * 0.25}
                  label="Start MP"
                  dataKey="leftStartMP"
                  cellRenderer={this.formatValue}
                />
                <Column
                  width={width * 0.25}
                  label="End Mp"
                  dataKey="leftEndMP"
                  cellRenderer={this.formatValue}
                />
                <Column
                  width={width * 0.25}
                  label="Track Name"
                  dataKey="leftTrackName"
                  cellRenderer={this.formatValue}
                />
                <Column
                  width={width * 0.25}
                  label="Code"
                  dataKey="code"
                  cellRenderer={this.formatValue}
                />
                <Column
                  width={width * 0.25}
                  label="Guid Id"
                  dataKey="rightGuidId"
                  cellRenderer={this.formatValue}
                />
                <Column
                  width={width * 0.25}
                  label="Start MP"
                  dataKey="rightStartMP"
                  cellRenderer={this.formatValue}
                />
                <Column
                  width={width * 0.25}
                  label="End Mp"
                  dataKey="rightEndMP"
                  cellRenderer={this.formatValue}
                />
                <Column
                  width={width * 0.25}
                  label="Track Name"
                  dataKey="rightTrackName"
                  cellRenderer={this.formatValue}
                />
              </Table>
            )}
          </AutoSizer>
        </div>
      </ContentBox>
    );
  },
});

function formatMp(mp) {
  var mpRegexNoDecimal = new RegExp(formValidation.regex.mpRegexNoDecimal);

  if (mpRegexNoDecimal.test(mp)) {
    return mp + ".0";
  }
  return mp;
}
